import TWEEN from '@tweenjs/tween.js'
import Menu from './Menu'
import { MODE, MQ_TABLET } from './const'

init()

async function init() {
	const mq = window.matchMedia(`(min-width: ${MQ_TABLET}) and (orientation:landscape)`)
	mq.addListener(() => window.location.reload())

	const mode = mq.matches ? MODE.LANDSCAPE : MODE.PORTRAIT
	const menu = new Menu(document.querySelector('.js-menu'), mode)
	menu.show(true, true)

	requestAnimationFrame(update)
}

function update() {
	requestAnimationFrame(update)
	TWEEN.update()
}
